import LoadingButton from '../../buttons/LoadingButton';
import ReactCodeInput from 'react-code-input';

const LoginPage2 = ({
	IsLoading,
	SubmitLogin,
	wrapperStyle,
	headerStyle,
	AdditionalButtonStyle,
	SetState,
}) => {
	const HandleCodeChange = (code) => {
		SetState(code);
	};

	return (
		<div className={wrapperStyle}>
			<>
				<div className={headerStyle}>Enter Verification Code</div>
				<ReactCodeInput
					type={'number'}
					inputMode="numeric"
					onChange={HandleCodeChange}
					fields={4}
					className="mx-auto font-arial mt-4 space-x-4"
					inputStyle={{
						color: 'gray',
						textAlign: 'center',
						borderBottomWidth: '1px',
						borderRadius: '0px',
						padding: '10px',
						paddingBottom: '0px',
						outline: 'none',
						borderBottomColor: 'gray',
						background: 'transparent',
						height: '7vh',
					}}
				/>
			</>
			<LoadingButton
				IsLoading={IsLoading}
				OnClick={async () => {
					await SubmitLogin();
				}}
				Message="Login"
				IsSecondary={false}
				AdditionalButtonStyle={AdditionalButtonStyle}
			/>
		</div>
	);
};

export default LoginPage2;
